import { useEffect, useState } from 'react';
import { Box, Fade, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';

export function SplashScreen({ duration = 6000, onFinish }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Fade
      in={show}
      timeout={{ enter: 0, exit: 700 }}
      appear={false}
      unmountOnExit
      onExited={onFinish}
    >
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 2000,
          bgcolor: '#000',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 4 },
          overflow: 'hidden',
          '@keyframes nbZoomOut': {
            from: { transform: 'scale(1.6)' },
            to: { transform: 'scale(1)' },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 3, md: 4 },
            transformOrigin: 'center center',
            animation: `nbZoomOut ${duration}ms ease-out forwards`,
          }}
        >
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/volleyball-large.png`}
            alt="Vôlei NB"
            sx={{ width: { xs: '55vw', md: '30vw' }, maxWidth: 300, height: 'auto' }}
          />
          <Typography
            sx={{
              fontFamily: 'monospace',
              fontWeight: 700,
              color: blue[400],
              fontSize: { xs: '2rem', md: '3.5rem' },
              letterSpacing: '.4rem',
            }}
          >
            Vôlei NB
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}
